import { AlertBlock } from "genesys-react-components";
import React, { useEffect, useState } from "react";
import "../App.css";
import { getDIDNumbers } from "../utilities/genesysCloudUtils";
import { Loading } from "./Loading"
import { CatalogTableSurface } from "./CatalogTableSurface";

export function DIDs({
  setPageCount,
  pageNumber,
  setPageNumber,
  setOpts,
  opts,
  setTabName,
  setIsVisible,
  selectedExportRows = {},
  exportStatus,
  onClearExportSelection,
  onExportCsv,
  onToggleExportRow,
  onToggleVisibleExportRows,
}) {
  const [dids, setDIDs] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  console.log("DIDs OPTS", opts);

  useEffect(() => {
    generateDIDs();
    setOpts({ numberMatch: "" })
  }, [pageNumber]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setPageNumber(1);
    setTabName("dids-tab");
    setIsVisible({ divisions: false, object: true, applyButton: true })
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setPageNumber(1);
    generateDIDs();
  }, [opts.numberMatch]); // eslint-disable-line react-hooks/exhaustive-deps

  const generateDIDs = () => {
    setLoading(true);
    setError(null);

    getDIDNumbers({
      pageSize: 100, // Number | Page size
      pageNumber: pageNumber,
      sortBy: "phoneNumber", // String | Sort by
      sortOrder: "ASC", // String | Ascending or descending sort order
      ...opts,
    })
      .then((data) => {
        setDIDs(data.entities);
        setPageCount(data.pageCount);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching DID numbers:", error);
        setError("Error fetching DID numbers: " + error);
        setLoading(false);
      });
  };

  const allVisibleSelected = dids.length > 0 && dids.every((did) => selectedExportRows[did.id || did.number]);

  return (
    <CatalogTableSurface
      allVisibleSelected={allVisibleSelected}
      exportStatus={exportStatus}
      filteredExportAvailable={true}
      loading={loading}
      onClearSelection={onClearExportSelection}
      onExportCurrent={() => onExportCsv({ mode: "current", records: dids })}
      onExportFiltered={() => onExportCsv({ mode: "all" })}
      onExportSelected={() => onExportCsv({ mode: "selected" })}
      onSelectVisible={(checked) => onToggleVisibleExportRows(dids, checked)}
      rowCount={dids.length}
      selectedCount={Object.keys(selectedExportRows).length}
      title="DIDs"
    >
      {loading && <Loading text="Loading DIDs..." />}
      {error && <AlertBlock
        title={error}
        alertType="critical"
        className="clazzy-alertblock error-search"
      />}
      {/* {error && <div className="error">{error}</div>} */}
      {!error && !loading && dids && (
        <table className="table">
          <thead>
            <tr>
              <th aria-label="Select rows" className="select-column"></th>
              <th className="count-column">Count</th>
              <th>DID</th>
              <th>Association</th>
            </tr>
          </thead>
          {dids ? (
            <tbody>
              {dids.map((did, index) => {
                return (
                  <tr key={index + 1}>
                    <td className="select-column">
                      <input
                        aria-label={`Select ${did.number} for export`}
                        checked={Boolean(selectedExportRows[did.id || did.number])}
                        onChange={(event) => onToggleExportRow(did, event.target.checked)}
                        type="checkbox"
                      />
                    </td>
                    <th className="index count-column">
                      {" "}
                      {pageNumber === 1
                        ? index + 1
                        : (pageNumber - 1) * 100 + index + 1}
                    </th>
                    <td>{did.number}</td>
                    <td>{did.owner ? did.owner.name : ""}</td>
                  </tr>
                );
              })}
            </tbody>
          ) : (
            <h1>Loading...</h1>
          )}
        </table>
      )}
    </CatalogTableSurface>
  );
}
